import axios from "axios";
import React, {Component} from "react";
import Resizer from "react-image-file-resizer";
import FeatherIcon from "feather-icons-react";
import { clearAppStoragePreservingTheme } from "../../theme/branding";

class ProfilImage extends Component{

    state = {
        id :  null,
        loading : false,
        loadingForm : false,
        btn : false,
        dataImage : "",
        image : [],
        error : "",
        errorImg : "",
        valid : "",
        user : {},
    }

    componentDidMount(){
    }

    handleInputFile = (e) => {

        this.setState({
            image : [],
            btn : false,
            dataImage : e.target.files[0],
        })
        for(var i = 0 ; i < e.target.files.length; i++)
        {
            this.setState({
                loading : true
            })
            var img = "";
            try {
            img =  Resizer.imageFileResizer(
                  e.target.files[i],
                  1500,
                  1500,
                  "JPEG",
                  100,
                  0,
                  (uri) => {
                        this.state.image.push(uri);
                    this.setState({ image: this.state.image });
                  },
                  "base64",
                  1000,
                  1000
                );
            } catch (err) {
                console.log(err);
            }
        }
        this.setState({
            errorImg : "",
            loading : false,
            loadingForm : false,
            dataImage : e.target.files[0],
        })
    }

    storeImage = async (e) => {
        e.preventDefault()
        this.setState({
            errorImg : "",
            loading : true,
            btn : !this.state.btn
        })

        let formData = new FormData()
        formData.append('files', this.state.dataImage)
        formData.append('userId', this.props.userId)

        const response = await fetch(process.env.REACT_APP_APIEVIVESOMA + '/files', {
            method: "POST",
            body: formData 
        })
        
        if (response.status === 200)
        {
            this.setState({
                loading : false,
                errorImg : "saved image",
                btn : !this.state.btn
            })
            var user = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : false;
            if(user && user.id == this.props.userId)
                this.refreshToken();
        }
        else{
            this.setState({
                loading : false,
                errorImg : "error",
                btn : !this.state.btn
            })
        }
    }
  
    async refreshToken () {
        try{
            var token = await axios.get('token');
            if(token.status == 200)
            {
                var user = (token.data.data);
                localStorage.setItem("user", JSON.stringify(user));
                window.location.replace(process.env.REACT_APP_EVIVESOMA_COMPTA + `/profile`)
            }
            else{
                axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
                clearAppStoragePreservingTheme();
                window.location.replace(process.env.REACT_APP_EVIVESOMA_COMPTA + `/login`)
            }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            clearAppStoragePreservingTheme();
            window.location.replace(process.env.REACT_APP_EVIVESOMA_COMPTA + `/login`)
        }
    }

    render(){
       
        const preview = this.state.image[0];
        const inputId = `profile-image-${this.props.userId || "new"}`;

        return(
            <section className="profile-image" aria-labelledby={`${inputId}-title`}>
                <form onSubmit={this.storeImage}>
                    <div className="profile-image__heading">
                        <span className="profile-image__heading-icon"><FeatherIcon icon="camera" size="18" /></span>
                        <div>
                            <h6 id={`${inputId}-title`}>Photo de profil</h6>
                            <p>Ajoutez une photo nette et bien cadrée.</p>
                        </div>
                    </div>

                    <div className="profile-image__content">
                        <div className={`profile-image__preview ${preview ? "has-image" : ""}`}>
                            {preview
                                ? <img src={preview} alt="Aperçu sélectionné" />
                                : <FeatherIcon icon="user" size="38" aria-hidden="true" />}
                        </div>

                        <div className="profile-image__picker">
                            <label htmlFor={inputId}>
                                <FeatherIcon icon="upload-cloud" size="17" />
                                <span>
                                    <strong>{this.state.dataImage ? "Changer de photo" : "Choisir une photo"}</strong>
                                    <small>JPG, PNG ou WEBP</small>
                                </span>
                            </label>
                            <input id={inputId} type="file" accept="image/*" name="file" onChange={this.handleInputFile} />
                            {this.state.dataImage && <span className="profile-image__filename" title={this.state.dataImage.name}><FeatherIcon icon="image" size="13" />{this.state.dataImage.name}</span>}
                        </div>
                    </div>

                    {this.state.loading && <div className="profile-image__loading"><FeatherIcon className="user-search-spin" icon="loader" /></div>}
                    {this.state.errorImg && <div className={`profile-image__message ${this.state.errorImg === "saved image" ? "is-success" : "is-error"}`} role="status"><FeatherIcon icon={this.state.errorImg === "saved image" ? "check-circle" : "alert-circle"} size="15" /><span>{this.state.errorImg === "saved image" ? "La photo a bien été mise à jour." : "L’envoi a échoué. Veuillez réessayer."}</span></div>}

                    <div className="profile-image__footer">
                        <span>Image carrée recommandée</span>
                        <button className="account-profile-primary" disabled={this.state.btn || !this.state.dataImage} type="submit"><FeatherIcon icon="save" size="15" />{this.state.btn ? "Enregistrement…" : "Enregistrer la photo"}</button>
                    </div>
                </form>
            </section>
        )
    }
}
export default ProfilImage;
